import { render } from "./TheDrawTextDialog.vue?vue&type=template&id=42c79714&scoped=true&ts=true"
import script from "./TheDrawTextDialog.vue?vue&type=script&lang=ts"
export * from "./TheDrawTextDialog.vue?vue&type=script&lang=ts"

import "./TheDrawTextDialog.vue?vue&type=style&index=0&id=42c79714&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c79714"]])

export default __exports__